import React from 'react'
import { Link } from 'react-router-dom'
import { logo } from '../assets'

export const Logo = () => {
  return (
    <Link to='/'>
        <div className="w-16 h-16 flex items-center gap-x-4">
          <img className="border-[1px] border-lightText rounded-full" src={logo} alt="logo" />
          <h4 className="text-lg font-normal uppercase">Fourat Abdellatif</h4>
        </div>
      </Link>
  )
}
